<template>
  <div class="vip-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input
          v-model="searchParams.vipNameLike"
          :placeholder="$t('user.vipNamePlaceholder')"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="6">
        <el-input
          v-model="searchParams.vipTel"
          :placeholder="$t('user.vipTelPlaceholder')"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="margin-top"
    >
      <el-table-column prop="shopName" label="店铺" align="center"></el-table-column>
      <el-table-column prop="vipId" label="会员编号" align="center"></el-table-column>
      <el-table-column prop="vipName" label="会员名称" align="center"></el-table-column>
      <el-table-column prop="vipTel" label="会员电话" align="center"></el-table-column>
      <el-table-column prop="sex" label="性别" align="center">
        <template #default="scope">
          {{ scope.row.sex === '0' ? $t('common.female') : $t('common.male') }}
        </template>
      </el-table-column>
      <el-table-column prop="levelName" label="会员等级" align="center"></el-table-column>
      <el-table-column prop="birthday" label="会员生日" align="center"></el-table-column>
      <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
      <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
    </el-table>

    <el-pagination
      class="margin-top"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    ></el-pagination>
  </div>
</template>

<script>
import { getVipList } from '@/api/user/userDetailVipApi'

export default {
  name: 'AShopDetailVip',

  data() {
    return {
      searchParams: {
        vipNameLike: '',
        vipTel: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          vipTel: this.searchParams.vipTel,
          vipNameLike: this.searchParams.vipNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }
        
        const res = await getVipList(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取会员列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.vip-container {
  padding: 20px;
}
.search-row {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
</style>